var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import cn from 'classnames';
import * as React from 'react';
import { Fragment } from 'react';
import theme from './TextLoading.module.scss';
export var TextLoading = React.memo(function (_a) {
    var className = _a.className, inline = _a.inline, children = _a.children;
    return inline ? (React.createElement("span", { className: cn(theme.inner, theme.inner_inline, className) }, children)) : (React.createElement("div", { className: cn(theme.container, className) },
        React.createElement("span", { className: cn(theme.inner) })));
});
export var RemoteDataText = React.memo(function (_a) {
    var text = _a.text, alt = _a.alt, props = __rest(_a, ["text", "alt"]);
    return (React.createElement(Fragment, null, text.getOrElseL(function () { return (React.createElement(TextLoading, __assign({}, props), alt)); })));
});
//# sourceMappingURL=TextLoading.js.map